import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corner-buttons',
  templateUrl: './corner-buttons.component.html',
  styleUrls: ['./corner-buttons.component.scss']
})
export class CornerButtonsComponent {
}
